import React from "react";
import { dynamicPlaceComponent } from "tsi-common-react/src/utils/react";

// Render standalone login forms
dynamicPlaceComponent('[data-place-react="offer-modal"]', async (elem) => {
    const { OfferModal } = await import(
        "tsi-common-react/src/blocks/containers/OfferModal"
    );
    const url = elem.dataset.url || "";
    // TODO(i18n): CTA text from data attribute should be translated before being passed from Django template
    const cta = elem.dataset.cta || "";
    const arrow = elem.hasAttribute("data-arrow");
    const button = elem.hasAttribute("data-button");
    return (
        <OfferModal
            offerDetailURL={url}
            ctaText={cta}
            ctaArrow={arrow}
            isButton={button}
        />
    );
}).catch(console.error);
